import React from "react";

const AnnouncementsCard = ({ items = [] }) => {
  return (
    <div className="col-span-12 lg:col-span-5 bg-[var(--surface)] rounded-2xl p-6 shadow-[0px_20px_50px_-32px_rgba(15,23,42,0.35)] border border-[var(--surface-border)]">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-[18px] font-semibold text-[var(--textBlack)]">Announcements</p>
          <p className="text-sm text-[var(--font-600)]">
            Product updates and changes
          </p>
        </div>
        {/* <span className="text-xs px-3 py-1 rounded-full bg-[var(--surface-muted)] border border-[var(--surface-border)]">
          New
        </span> */}
      </div>

      <div className="mt-6 p-3 flex flex-col gap-3 max-h-[300px] overflow-y-auto listScroll ">
        {items.length === 0 ? (
          <div className="border border-dashed border-[#E8E8EA] rounded-xl p-6 text-center text-[var(--font-600)] bg-[var(--surface-muted)]">
            No announcements right now.
          </div>
        ) : (
          items.map((item) => (
            <div
              key={item.id}
              className="relative border border-[var(--surface-border)] rounded-xl px-4 py-3 bg-[var(--surface-muted)] hover:border-[var(--accent-2)] hover:-translate-y-0.5 transition-all duration-200"
            >
              <span className="absolute left-0 top-3 bottom-3 w-1 rounded-l-xl bg-gradient-to-b from-[#6940F2] to-[#0ACD95] opacity-70" />
              <div className="flex items-start justify-between gap-2 pl-2">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="font14px-600 text-[var(--textBlack)]">
                    {item.title}
                  </p>
                  {item.tag && (
                    <span className="text-[10px] uppercase tracking-wide font-semibold px-2 py-1 rounded-full bg-[#ECFDF3] text-[#027A48] border border-[#BBF7D0]">
                      {item.tag}
                    </span>
                  )}
                </div>
              </div>
              <p className="mt-1 text-sm text-[var(--font-600)]">
                {item.description}
              </p>
              {item.actionLabel && (
                <button
                  type="button"
                  onClick={() => item.action?.()}
                  className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-[var(--accent-2)] hover:text-[var(--primary)] transition-colors"
                >
                  {item.actionLabel}
                  <span className="text-[10px]">{'>'}</span>
                </button>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AnnouncementsCard;
